export const DRIP_BOX_BG = "#131B26";
export const DRIP_BOX_BG_HOVER = "#1a2433";
export const DRIP_FIELD_INPUT_BG = "#1a2433";
export const DRIP_FIELD_OUTPUT_BG = "#0f1520";
export const DRIP_TRACK_BG = "#0c1117";
export const DRIP_SEGMENT_ACTIVE_BG = "#1e2a3a";
export const DRIP_TEXT_SECONDARY = "whiteAlpha.800";
export const DRIP_TEXT_LABEL = "whiteAlpha.700";
export const DRIP_TEXT_MUTED = "whiteAlpha.600";
export const DRIP_BORDER = "whiteAlpha.200";

export const DRIP_CHART_FONT = "Poppins, sans-serif";
export const DRIP_CHART_TICK_COLOR = "rgba(255, 255, 255, 0.64)";
export const DRIP_CHART_GRID_COLOR = "rgba(255, 255, 255, 0.08)";
export const DRIP_CHART_TOOLTIP_BG = "rgba(19, 27, 38, 0.96)";
export const DRIP_CHART_TOOLTIP_TITLE = "rgba(255, 255, 255, 0.92)";
export const DRIP_CHART_TOOLTIP_BODY = "rgba(255, 255, 255, 0.80)";

export const dripSurfaceSx = {
  bg: DRIP_BOX_BG,
  borderRadius: "xl",
  border: "1px solid",
  borderColor: DRIP_BORDER,
};

export interface DripTokenMeta {
  symbol: string;
  image?: string;
}
